import { client as apolloClient } from '../config/apollo'
export const clientPromise = apolloClient(process.env.API_URL)
